import { ToolbarSearchField } from "@/components/ui/toolbar-search-field"
import { useTranslation } from "@/hooks/use-translation"

/**
 * Поле поиска в шапке Библиотеки. Видно всегда — раньше оно пряталось на узких
 * экранах вместе с единственным способом что-то найти.
 */
export function LibrarySearchField({
  value,
  onChange,
  loading = false,
  tooShort = false,
  autoFocus = false,
}: {
  value: string
  onChange: (next: string) => void
  loading?: boolean
  /** Введено меньше минимума: объясняем это подсказкой поля, а не текстом в шапке —
   *  появляющаяся и исчезающая строка двигала бы соседние блоки при наборе. */
  tooShort?: boolean
  /** Забрать фокус при появлении — в модалке выбора кадра. */
  autoFocus?: boolean
}) {
  const { t } = useTranslation(["workspace"])

  return (
    <ToolbarSearchField
      value={value}
      onChange={onChange}
      placeholder={t("library.search.placeholder")}
      title={tooShort ? t("library.search.tooShort") : t("library.search.hint")}
      clearLabel={t("library.search.clear")}
      loading={loading}
      autoFocus={autoFocus}
      // shrink-0 у поля снят: на узкой шапке оно ужимается, а не выталкивает крошки.
      // Пол 9rem, но не шире родителя — иначе на второй строке w-72 торчит за край.
      className="h-8 w-44 max-w-full min-w-[min(100%,9rem)] shrink sm:w-60 md:w-72"
    />
  )
}
